export default "__VITE_ASSET__DpEJ$Yum__"